import * as SSR from "../../api/hooks/lib/ssr.js"
import { addMessages, init, getLocaleFromNavigator, locale } from "svelte-i18n"
import { writable } from "svelte/store"

import de from "./../locales/de.json"
import fr from "./../locales/fr.json"
import se from "./../locales/se.json"
import dk from "./../locales/dk.json"

addMessages("de", de)
addMessages("fr", fr)
addMessages("se", se)
addMessages("dk", dk)

export const fallbackLocale = "de"
export const navigatorLocale = getLocaleFromNavigator() || fallbackLocale
export const initialLocale = "de" // navigatorLocale.replace(/\-.+$/, "") // no multilang support yet

console.log("locale: ", navigatorLocale, initialLocale)

init({
    fallbackLocale,
    initialLocale,
})

export function langField(field: any, _default?: any): any {
    if (field) {
        const prio = [initialLocale, "en", "de", "fr", "se", "dk"]
        for (let i = 0; i < prio.length; i++) {
            if (field[prio[i]]) {
                return field[prio[i]]
            }
        }
    }
    return _default
}

function getCurrencyFormater(locale: string) {
    return (price: number, vatPercent = 0, quantity = 1) => {
        return SSR.formatPrice(price, vatPercent, quantity, locale, true) as string
    }
}

export const formatPriceCurrency = writable(getCurrencyFormater(navigatorLocale))

locale.subscribe((l) => {
    formatPriceCurrency.set(getCurrencyFormater(l))
})
